<template>
  <div class="newslist">
    <section class="main">
      <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/pin.jpg" alt />
      </div>
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>品牌「栗」史</el-breadcrumb-item>
          <el-breadcrumb-item>品牌快讯</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="nlist">
        <!-- 区域标题：呼应首页"品牌快讯"卡片设计 -->
        <div class="nlist_header">
          <div class="header_en">BRAND NEWS</div>
          <div class="header_cn">品牌快讯</div>
          <div class="header_decor">
            <span class="decor_line"></span>
            <span class="decor_dot"></span>
            <span class="decor_line"></span>
          </div>
        </div>
        <!-- 新闻列表 -->
        <div class="nlist_body">
          <div
            class="nlist_item"
            v-for="(item,index) in list"
            :key="index"
            @click="goDetail(item.url)"
          >
            <!-- 序号装饰，两位数格式（01/02/03） -->
            <div class="item_index">{{ index < 9 ? '0' + (index + 1) : (index + 1) }}</div>
            <!-- 标题主体 -->
            <div class="item_main">
              <h3 class="news_tit">{{item.title}}</h3>
              <div class="news_bar"></div>
            </div>
            <!-- 跳转箭头 -->
            <div class="item_arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 品牌快讯新闻列表（外部链接，使用Object.freeze冻结避免运行时修改）
      list: Object.freeze([
        {
          title: "粒上皇连续三年荣获【广东3·15放心消费品牌】",
          url: "https://m.tech.china.com/redian/2026/0320/032026_1829190.html"
        },
        {
          title: "粒上皇荣获“中国现炒板栗销量第一品牌”",
          url: " https://qiye.chinadaily.com.cn/a/202606/30/WS6a436182a310d709c2fbaff6.html"
        },
        {
          title: "2026粒上皇冠名高铁列车",
          url: "https://baijiahao.baidu.com/s?id=1858085612512681323&wfr=spider&for=pc"
        },
        {
          title: "粒上皇亮相第27届簕杜鹃赏花周",
          url: "https://digi.china.com/articles/20251108/202511081761440.html"
        }
      ])
    };
  },
  methods: {
    // 点击标题跳转至外部新闻页面
    goDetail(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.newslist {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .nlist {
    width: 1000px;
    margin: 0 auto;
    padding: 60px 0 120px;
    text-align: left;

    // 区域标题：大号英文背景字 + 中文前景字叠加，呼应首页设计语言
    .nlist_header {
      position: relative;
      text-align: center;
      margin-bottom: 56px;
      .header_en {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: 'HarmonyOS Sans SC';
        font-size: 42px;
        color: rgba(76, 1, 4, 0.06);
        line-height: 1;
        font-weight: 500;
      }
      .header_cn {
        position: relative;
        z-index: 1;
        font-family: 'HarmonyOS Sans SC';
        font-size: 28px;
        color: #4c0104;
        font-weight: 500;
        line-height: 1;
        padding-top: 18px;
      }
      // 标题下方装饰：线 - 点 - 线
      .header_decor {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .decor_line {
          width: 40px;
          height: 1px;
          background: #d0a87a;
        }
        .decor_dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #d0a87a;
          margin: 0 10px;
        }
      }
    }

    // 新闻列表卡片
    .nlist_body {
      .nlist_item {
        display: flex;
        align-items: center;
        padding: 28px 32px;
        margin-bottom: 20px;
        cursor: pointer;
        background: #fff;
        border: 1px solid #f0ebe5;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        transition: all 0.4s ease;

        // 左侧装饰色条：hover 时纵向展开，强化品牌色
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: #4c0104;
          transform: scaleY(0);
          transform-origin: center;
          transition: transform 0.4s ease;
        }

        &:hover {
          background: #fdfaf6;
          border-color: #e8dcc8;
          box-shadow: 0 8px 24px rgba(76, 1, 4, 0.08);
          transform: translateY(-2px);
          &::before {
            transform: scaleY(1);
          }
          .item_index {
            color: #4c0104;
          }
          .news_tit {
            color: #4c0104;
          }
          .news_bar {
            width: 100%;
            opacity: 1;
          }
          .item_arrow {
            background: #4c0104;
            i {
              color: #fbea11;
              transform: translateX(0);
            }
          }
        }

        // 序号：暖金色大字，hover 时变品牌主色
        .item_index {
          font-family: 'HarmonyOS Sans SC';
          font-size: 36px;
          font-weight: 500;
          color: #d8c9b4;
          line-height: 1;
          min-width: 60px;
          transition: color 0.4s ease;
        }

        // 标题主体
        .item_main {
          flex: 1;
          padding: 0 24px;
          .news_tit {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #151515;
            line-height: 28px;
            transition: color 0.3s ease;
          }
          // 标题下方动画下划线：hover 时从左展开
          .news_bar {
            width: 0;
            height: 2px;
            background: #d0a87a;
            margin-top: 10px;
            opacity: 0;
            transition: all 0.4s ease;
          }
        }

        // 右侧圆形箭头：hover 时填充品牌色并位移
        .item_arrow {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #f5f0e8;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s ease;
          i {
            font-size: 16px;
            color: #b89a6e;
            transform: translateX(-4px);
            transition: all 0.3s ease;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
</style>
